





















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import SelectEntity from "@/components/form/SelectEntity.vue";
import lectures, { LectureListParams } from "@/getinfo-api/lectures-short";
import { LectureShortList as ILectureShortList } from "@/api/models/lecture-short-list";
import { LectureShort as ILectureShort } from "@/api/models/lecture-short";
import LectureListItemTables from "@/components/lectures/LectureListItemTables.vue";
import { LecturesSort, SortFields } from "@/plugins/sort-fields";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CustomButton,
    CustomTableCol,
    CustomTable,
    SelectEntity,
    LectureListItemTables,
    CPage,
    CField
  }
})
export default class lectureListView extends Vue {
  ownerId: string | undefined;
  enabled: boolean | undefined = true;
  searchTitle!: string | undefined;
  limit: number = 30;
  offset: number = 0;
  lecturesLists: Array<ILectureShort> = [];
  showSpinner: boolean = false;
  lecturesCount: number = 0;
  sorted: SortFields<LecturesSort> = new SortFields<LecturesSort>(
    LecturesSort.updatedAt
  );
  contentManagers!: EmployeesListClass;
  locale: string | undefined = "";

  data() {
    return {
      teacher: undefined,
      ownerId: undefined,
      searchTitle: undefined,
      contentManagers: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get sortStatus() {
    return LecturesSort;
  }

  acceptSort(sort: LecturesSort) {
    this.sorted.changeSort(sort);
    this.lecturesLists = [];
    this.offset = 0;
    this.getListLecturesId();
  }

  reload() {
    this.searchTitle = "";
    this.lecturesLists = [];
    this.ownerId = undefined;
    this.locale = undefined;
    this.enabled =
      this.root || this.contentManager || this.companyOwner ? undefined : true;
    this.offset = 0;
    this.lecturesCount = 0;
    this.getListLecturesId();
    this.getEmployee();
  }

  submitSettings() {
    this.lecturesLists = [];
    this.offset = 0;
    this.lecturesCount = 0;
    this.getListLecturesId();
  }

  getListLecturesId(offset: number = 0) {
    this.showSpinner = true;
    let params: LectureListParams = {
      companyId: this.selectedCompanyId,
      ownerId: this.root || this.companyOwner ? this.ownerId : this.userId,
      title: this.searchTitle,
      enabled: this.enabled,
      limit: this.limit,
      sort: this.sorted.sort,
      order: this.sorted.order,
      locale: this.locale,
      offset: offset
    };
    lectures(params)
      .then((res: { data: ILectureShortList }) => {
        this.lecturesLists = [...this.lecturesLists, ...res.data.lectures];
        this.lecturesCount = res.data.count;
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  showMore() {
    this.offset += this.limit;
    this.getListLecturesId(this.offset);
  }

  getEmployee() {
    if (this.root || this.companyOwner) {
      this.contentManagers = new EmployeesListClass({
        id: this.selectedCompanyId,
        roles: ["content_manager"]
      });
    }
  }

  @Watch("selectedCompanyId")
  updateCourses() {
    this.reload();
  }

  created() {
    this.getListLecturesId();
    this.getEmployee();
  }
}
